import dayjs from 'dayjs'

/**
 * The last day a dashboard range covers: today.
 *
 * The analytics views count days in Warsaw (ai-api migration 0002), where
 * every venue is today, and the owner's browser is there too. It used to be
 * a fixed '2025-12-01', which left every sale after that date off the charts.
 */
export const dashboardEndDate = (): string => dayjs().format('YYYY-MM-DD')

/** `days` calendar days before a `YYYY-MM-DD` date, in the same format. */
export const daysBefore = (date: string, days: number): string =>
  dayjs(date).subtract(days, 'day').format('YYYY-MM-DD')
